const now = () => new Date().getTime();
const weekAgo = () => now() - 1000 * 60 * 60 * 24 * 7;
const minuteAgo = () => now() - 1000 * 60;
const isInThePast = (time) => new Date(time).getTime() <= now();
export const isLessThanMinute = (time) => {
    const timeMs = new Date(time).getTime();
    return isInThePast(time) && timeMs > minuteAgo();
};
const isLessThanWeek = (time) => {
    const timeMs = new Date(time).getTime();
    return isInThePast(time) && timeMs > weekAgo();
};
const isNotCurrentYear = (time) => new Date().getFullYear() !== new Date(time).getFullYear();
export const getTimeAgoFormat = (time) => {
    if (isLessThanWeek(time)) {
        return 'timeRelative';
    }
    if (isNotCurrentYear(time)) {
        return 'fullDate';
    }
    return 'date';
};
//# sourceMappingURL=time-ago.js.map